<template>
  <div class="image-text-item" :class="{ 'image-text-item--keep-ratio': variantTwoImages }">
    <figure>
      <div class="image-text-item__wrapper">
        <base-image
          class="image-text-item__image"
          :desktop-url="image?.value?.src"
          :desktop-alt="image?.value?.alt"
          :desktop-dimensions="[Number(image?.value?.width), Number(image?.value?.height)]"
          :mobile-dimensions="[Number(image?.value?.width), Number(image?.value?.height)]"
          :tablet-dimensions="[Number(image?.value?.width), Number(image?.value?.height)]"
          :custom-params="{ desktop: 1024 }"
          lazy-loading="lazy"
        />
      </div>
      <sc-text tag="figcaption" class="image-text-item__text" :field="description" />
    </figure>
  </div>
</template>

<script setup lang="ts">
import { Text as ScText } from '@sitecore-jss/sitecore-jss-vue';
import BaseImage from '../../2_elements/BaseImage/BaseImage.vue';
import type { ImageTextItemProps } from '../types';

withDefaults(defineProps<ImageTextItemProps>(), {
  variantTwoImages: false,
});
</script>

<style lang="scss">
@import './scss/ImageTextItem.scss';
</style>
